import template from './PageTable.html';

export default {
	template,
	props: [
		'query',
		'remoteMethod',
		'remoteStatMethod',
		'exportMethod',
		'beforeExportFn',
		'fieldMap',
		'hiddenFields',
		'noSortFields',
		'localControl',
		'portionSize',
		'initPortionSize',
		'filterFn',
		'noSort',
		'transformRowFn',
		'width',
		'reloadParam',
		'smallHeader',
		'stat-fn',
		'defLocSortField',
		'show-more-text',
		'no-loading'
	],
	data() {
		return {
			statList: null,
			totalCnt: null,
			res: null,
			stat: null,
			rows: null,
			isLoadingMore: false,
			isNoMore: false,
			portion: 0,
			loadTime: null,
			defaultPortionSize: 50,
			localShownCnt: 0,
			isExporting: false,
			lastGetStatRequest: 0,
			loadedIds: [],
			localRowsExpanded: false,
			tblRenderKey: 0
		};
	},
	computed: {
		params() {
			return this.query || this.app.query;
		},
		fields() {
			if (!this.rows || !this.rows[0]) return null;

			return Object.keys(this.rows[0]).filter(key => this.hiddenFieldsArr.indexOf(key) === -1);
		},
		hiddenFieldsArr() {
			if (!this.hiddenFields) return [];
			return this.hiddenFields.split(',');
		},
		noSortFieldsArr() {
			if (!this.noSortFields) return [];
			return this.noSortFields.split(',');
		},
		handledRows() {
			if (!this.rows) return null;
			if (!this.localControl) return this.rows;

			let rows = this.rows;
			let sort = this.params.sort || this.defLocSortField;
			if (sort) {
				let key = sort;
				if (sort.startsWith('-'))
					key = sort.substr(1);
				let dir = sort.startsWith('-') ? 1 : -1;
				rows = rows.sort((a, b) => {
					if (a[key] === null) return dir;
					if (b[key] === null) return -dir;
					if (a[key] < b[key]) return dir;
					if (a[key] > b[key]) return -dir;
					return 0;
				});
			}

			if (this.filterFn) {
				rows = rows.filter(this.filterFn);
			}

			this.totalCnt = rows.length;

			if (this.initPortionSize && !this.localRowsExpanded) {
				rows = rows.slice(0, parseInt(this.initPortionSize));
			}

			return rows;
		},
		tblBoxStyle() {
			if (!this.width) return null;
			let w = isNaN(this.width) ? this.width : (this.width + 'px');
			return {minWidth: w};
		}
	},
	methods: {
		async getRows(opts = {}) {
			if (this.isLoading) return;

			let httpMethod;
			if (opts.isAppend) {
				if (this.isNoMore) return;

				this.portion++;
				this.isLoadingMore = true;
				httpMethod = 'post';
			} else {
				this.portion = 1;
				this.isNoMore = false;
				this.loadTime = null;
				this.setAppLoading(true);
				this.loadedIds = [];

				this.tryLoadStat();
				httpMethod = 'get';
			}

			this.isLoading = true;
			let portion = this.portion;

			this.res = null;
			let params = opts.params || this.params;
			let res = await this.http[httpMethod](this.remoteMethod, params, this.loadedIds, opts.extraData);

			this.isLoading = false;
			this.isLoadingMore = false;
			this.setAppLoading(false);

			this.$emit('load', res, portion);

			let rows = res.rows;
			if (this.transformRowFn) {
				rows = rows.map(this.transformRowFn);
			}
			if (res.totalCnt != null && portion === 1) {
				this.totalCnt = res.totalCnt;
			}

			rows.forEach(row => this.loadedIds.push(row.id));

			if (!opts.isAppend) {
				if (this.localControl) {
					this.localShownCnt = this.initPortionSize || this.portionSize || this.defaultPortionSize;
				}
				this.rows = [];
			}

			this.res = res;

			if (!rows.length) {
				this.isNoMore = true;
				return;
			}

			this.rows = this.rows.concat(rows);
		},
		setAppLoading(isLoading) {
			if (this.noLoading) return;
			this.app.isLoading = isLoading;
		},
		async tryLoadStat() {
			/*if (!this.remoteStatMethod || this.localControl) return;

			this.statList = null;
			this.totalCnt = -1;

			let requestNumber = ++this.lastGetStatRequest;

			this.stat = null;
			let stat = await this.get(this.remoteStatMethod, this.params);
			if(requestNumber !== this.lastGetStatRequest) return;
			this.totalCnt = stat.totalCnt;

			if (this.statFn) {
				this.statList = this.statFn(stat);
			}

			this.stat = stat;*/
		},
		async exportFile() {
			let data;
			if (this.beforeExportFn) {
				data = await this.beforeExportFn();
				if (!data) return;
			}
			this.isExporting = true;
			await this.download(this.exportMethod, this.params, data);
			this.isExporting = false;
		},
		getFieldText(field) {
			return this.fieldMap && this.fieldMap[field] || field;
		},
		isTimestamp(val) {
			if (isNaN(val)) return false;
			return (val > 1300000000 && val < 1600000000);
		},
		reload(opts) {
			this.getRows(opts);
		},
		onScrollToBottom() {
			if (this.localControl) {
				this.localShownCnt += this.portionSize || this.defaultPortionSize;
			} else {
				this.getRows({isAppend: true});
			}
		},
		onScroll() {
			if (this.initPortionSize) return;

			let OFFSET = 200;

			let scrollBottom = this.win.scrollTop + this.win.height;
			let docHeight = document.body.scrollHeight;

			if (scrollBottom > docHeight - OFFSET) {
				this.onScrollToBottom();
			}
		}
	},
	watch: {
		params() {
			if (this.localControl) {
				this.localShownCnt = this.portionSize || this.defaultPortionSize;
			}
		},
		reloadParam() {
			this.getRows();
		}
	},
	async mounted() {
		this.getRows();

		window.addEventListener('scroll', this.onScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.onScroll);
	}
};
